/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {MerchantQueueAddDto} from '../models/MerchantQueueAddDto'
import type {MerchantQueueDtoListSuccessDataResult} from '../models/MerchantQueueDtoListSuccessDataResult'
import type {MerchantQueueDtoSuccessDataResult} from '../models/MerchantQueueDtoSuccessDataResult'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'
import {uploadBase64} from 'helpers/cloudinary'
import slugify from 'slugify'

export class MerchantQueueService {
  /**
   * @param requestBody
   * @returns MerchantQueueDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static async postApiMerchantQueueAdd(
    requestBody?: MerchantQueueAddDto
  ): Promise<CancelablePromise<MerchantQueueDtoSuccessDataResult>> {
    const localStore = JSON.parse(localStorage.getItem('user'))?.store
    const payload = {...requestBody}

    if (requestBody.logoBase64Content) {
      const {url = null} = await uploadBase64(requestBody.logoBase64Content)
      payload['logoUrl'] = url
    }
    return __request(OpenAPICouponCenter, {
      method: 'PUT',
      url: `/api/v1/stores/${localStore.slug}`,
      body: {
        name: payload.name,
        contact_first_name: payload.firstName,
        contact_last_name: payload.lastName,
        contact_email: payload.email,
        stripe_payment_email: payload.stripe_payment_email?.trim() || null,
        logo_url: payload.logoUrl,
        website_url: payload.url,
        affiliate_website_url: payload.url,
        client: process.env.REACT_APP_CLIENT_ID,
        location: process.env.REACT_APP_CLIENT_LOCATION,
        slug: localStore.slug,
      },
      query: {
        id: localStore.id,
        client: localStore.client,
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param id
   * @returns MerchantQueueDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantQueueGet(
    id?: number
  ): CancelablePromise<MerchantQueueDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/MerchantQueue/Get',
      query: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns MerchantQueueDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantQueueGetByMerchantId(
    merchantId?: number
  ): CancelablePromise<MerchantQueueDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: `/api/v1/stores/${merchantId}/`,
      query: {
        merchantId: merchantId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param advertiserId
   * @returns MerchantQueueDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantQueueGetByAdvertiserId(
    advertiserId?: number
  ): CancelablePromise<MerchantQueueDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/MerchantQueue/GetByAdvertiserId',
      query: {
        advertiserId: advertiserId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
